<template>
  <!-- 견적 요청서 내용 -->
  <div>
    <admin-box-item title="견적요청서 조회" :useTab="false">
      <div class="columns is-multiline" v-if="value.selectedItem">
        <div class="column is-full">
          <table class="table">
            <tr><th>신청자명</th><th>견적요청 일시</th><th>연락처</th><th>이메일</th></tr>
            <tr>
              <td>{{ value.selectedItem.name }}</td>
              <td>{{ value.selectedItem.created_time }}</td>
              <td>{{ value.selectedItem.phone }}</td>
              <td>{{ value.selectedItem.email }}</td>
            </tr>
          </table>
        </div>
        <div class="column is-full">
          <admin-form-item class="form-item">
            <div>
              <div :key="'est'+idx" v-for="(step, idx) in value.selectedItem.steps">
                <div style="margin-bottom: 4px;font-weight: bold;">{{ idx+1 }}. {{ step.title }}</div>
                <div v-for="(form,answer_idx) in step.forms"
                     class="lp-estimate-qna"
                     :key="'answer-'+answer_idx">
                  <div style="margin-bottom: 4px;font-weight:500">Q. {{ form.question }}</div>
                  <div style="margin-bottom: 24px;"><span style="color:#ff5722">A.</span> {{ form.answer }}</div>
                </div>
              </div>
            </div>
          </admin-form-item>
        </div>
      </div>
    </admin-box-item>
  </div>
</template>

<script>

  import AdminFormItem from "../admin/AdminFormItem";
  import LpAdmDropInput from "../common/LpAdmDropInput";

  export default {
    props: ['data'],
    components: {
      LpAdmDropInput,
      AdminFormItem
    },
    data() {
      return {
        value: {
          selectedItem:{
            name:'',
            email:'',
            created_time:'',
            phone:'',
            steps:[]
          }
        }
      }
    },
    computed: {},
    created() {
      this.value = this.data;
    },
    watch: {
      data(n) {
        if (n) {
          this.value = n;
        }
      }
    },
    methods: {}
  }
</script>
<style lang="stylus" type="stylus" scoped>
  .lp-estimate-qna
    margin-bottom 12px

  .lp-estimate-qna:last-child
    margin-bottom 0

  .form-item
    overflow-y auto
    /*height calc(100% - 150px)*/
    height 250px
    border 1px solid #ddd
    padding 20px

</style>

<style lang="stylus">
  .v--modal-overlay .v--modal-box
    max-height 90vh
</style>
